import { render, staticRenderFns } from "./PanelDirectory.vue?vue&type=template&id=06668ac6&lang=pug"
import script from "./PanelDirectory.vue?vue&type=script&lang=js"
export * from "./PanelDirectory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports